import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { rupee } from "@/lib/constants";
import { toast } from "sonner";
import { TicketPercent, Loader2, X } from "lucide-react";

export function CouponBox({ b, onChange }) {
    const est = b.estimate;
    const [code, setCode] = useState("");
    const [busy, setBusy] = useState(false);
    const run = async (fn, ok) => {
        setBusy(true);
        try { await fn(); toast.success(ok); setCode(""); await onChange(); }
        catch (err) { toast.error(apiError(err.response?.data?.detail)); }
        finally { setBusy(false); }
    };
    if (est.coupon_code) {
        return (
            <div data-testid="coupon-applied" className="mt-3 flex items-center justify-between rounded-xl border border-dashed border-teal/40 bg-aqua-light/40 px-3 py-2 text-xs">
                <span className="flex items-center gap-1.5 font-bold text-teal-dark"><TicketPercent size={14} /> {est.coupon_code} applied · −{rupee(est.coupon_discount)}</span>
                <button data-testid="coupon-remove-btn" disabled={busy} aria-label="Remove coupon" onClick={() => run(() => api.delete(`/bookings/${b.id}/coupon`), "Coupon removed")} className="text-navy/40 hover:text-red-500"><X size={14} /></button>
            </div>
        );
    }
    return (
        <div className="mt-3 flex gap-2" data-testid="coupon-box">
            <input data-testid="coupon-input" aria-label="Coupon code" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="Have a coupon code?" className="min-w-0 flex-1 rounded-full border border-navy/15 px-3.5 py-2 text-xs font-semibold uppercase tracking-wide outline-none focus:border-teal" />
            <button data-testid="coupon-apply-btn" disabled={busy || code.trim().length < 3} onClick={() => run(() => api.post(`/bookings/${b.id}/coupon`, { code }), "Coupon applied")} className="rounded-full bg-teal px-4 text-xs font-bold text-white disabled:opacity-50">{busy ? <Loader2 size={14} className="animate-spin" /> : "APPLY"}</button>
        </div>
    );
}
